"use client";

import { ReactNode, useContext, useEffect, useRef } from "react";

import { FloatingContext } from "./floating-images.wrapper";

interface FloatingElementProps {
  children: ReactNode;
  className?: string;
  depth?: number;
}

export const FloatingElement = ({
  children,
  className,
  depth = 1,
}: FloatingElementProps) => {
  const elementRef = useRef<HTMLDivElement>(null);
  const idRef = useRef(Math.random().toString(36).substring(7));
  const context = useContext(FloatingContext);

  useEffect(() => {
    if (!elementRef.current || !context) return;

    const nonNullDepth = depth ?? 0.01;

    context.registerElement(idRef.current, elementRef.current, nonNullDepth);
    return () => context.unregisterElement(idRef.current);
  }, [depth]);

  return (
    <div
      ref={elementRef}
      className={`absolute will-change-transform overflow-hidden rounded-md ${className}`}
    >
      {children}
    </div>
  );
};
